<p>widget-max-values works!</p>
